module.exports = __webpack_public_path__ + "img/star_A.0263ddfc.svg";